import React from 'react'
import About from './About'

const Blogs = () => {
  return (
<About />
  )
}

export default Blogs